module.exports = __webpack_public_path__ + "img/cn.32da0165.svg";